import { render, staticRenderFns } from "./TheBackground.vue?vue&type=template&id=54e78116&scoped=true&"
import script from "./TheBackground.vue?vue&type=script&lang=js&"
export * from "./TheBackground.vue?vue&type=script&lang=js&"
import style0 from "./TheBackground.vue?vue&type=style&index=0&id=54e78116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e78116",
  null
  
)

export default component.exports